import { render, staticRenderFns } from "./AddOportunityClientView.vue?vue&type=template&id=1895be89&scoped=true&lang=pug"
import script from "./AddOportunityClientView.vue?vue&type=script&lang=js"
export * from "./AddOportunityClientView.vue?vue&type=script&lang=js"
import style0 from "./AddOportunityClientView.vue?vue&type=style&index=0&id=1895be89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1895be89",
  null
  
)

export default component.exports